import { Check } from "@mui/icons-material";
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getSpacedFromCamel_Cap } from "../../../util/string";

interface SuccessStepProps {
    importType: 'jobs' | 'users';
    previewDataLength: number;
    onReset: () => void;
}

const SuccessStep = ({
    importType,
    previewDataLength,
    onReset
}: SuccessStepProps) => {
    const navigate = useNavigate();

    return (
        <Paper
            elevation={3}
            sx={{
                p: 4,
                maxWidth: 600,
                mx: 'auto',
                borderRadius: 2,
                // background: 'linear-gradient(145deg, #ffffff, #f0f0f0)'
            }}
        >
            <Stack alignItems="center" gap={3}>
                <Box
                    sx={{
                        width: 60,
                        height: 60,
                        borderRadius: '50%',
                        backgroundColor: 'success.light',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)'
                    }}
                >
                    <Check
                        sx={{
                            fontSize: 40,
                            color: 'white'
                        }}
                    />
                </Box>

                <Typography
                    variant="h5" fontWeight='bold' color='success.main' textAlign='center'                >
                    Import Successful!
                </Typography>

                <Typography variant="subtitle1" color="text.secondary"                >
                    {previewDataLength} {importType} have been imported successfully.
                </Typography>

                <Stack
                    direction="row"
                    gap={2}
                    sx={{ mt: 2 }}
                >
                    <Button
                        variant="outlined"
                        onClick={() => navigate(`/${importType}`)}
                        startIcon={<VisibilityIcon />}
                        sx={{
                            borderColor: 'primary.main',
                            color: 'primary.main',
                            '&:hover': {
                                borderColor: 'primary.dark',
                                backgroundColor: 'primary.light',
                                color: 'primary.dark'
                            }
                        }}
                    >
                        View {getSpacedFromCamel_Cap(importType)}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onReset}
                        startIcon={<AddIcon />}
                        sx={{
                            backgroundColor: 'primary.main',
                            '&:hover': {
                                backgroundColor: 'primary.dark'
                            }
                        }}
                    >
                        Import More
                    </Button>
                </Stack>
            </Stack>
        </Paper >
    );
};

export default SuccessStep; 